import { render, staticRenderFns } from "./IconOvertime.vue?vue&type=template&id=30a83284&"
import script from "./IconOvertime.vue?vue&type=script&lang=js&"
export * from "./IconOvertime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports